import { AccessEventVisitor } from 'graphql/generated/graphqlTypes';

export function generateMockAccessEventVisitor({
  email = 'mockAccessEventVisitorEmail',
  id = 'mockAccessEventVisitorId',
  name = 'mockAccessEventVisitorName'
}: Partial<Omit<AccessEventVisitor, '__typename'>>): AccessEventVisitor {
  return {
    __typename: 'AccessEventVisitor',
    email,
    id,
    name
  };
}
